import React, { useState, useRef, useCallback } from 'react';
import ReactSelect, { components } from 'react-select';

// Componente MenuList customizado: fecha o menu quando a rolagem chega ao topo/fundo
const AutoCloseMenuList = (props) => {
  const listRef = useRef(null);

  const handleWheel = useCallback((e) => {
    const el = listRef.current;
    if (!el) return;
    const atTop = el.scrollTop <= 0;
    const atBottom = el.scrollTop + el.clientHeight >= el.scrollHeight - 1;
    const delta = e.deltaY;

    // Impede que a rolagem "vaze" para o body
    const prevent = () => {
      e.preventDefault();
      e.stopPropagation();
    };

    if ((atBottom && delta > 0) || (atTop && delta < 0)) {
      prevent();
      // Fecha o menu ao atingir o limite
      if (typeof props.selectProps.__setMenuOpen === 'function') {
        props.selectProps.__setMenuOpen(false);
      } else if (typeof props.selectProps.onMenuClose === 'function') {
        props.selectProps.onMenuClose();
      }
    }
  }, [props.selectProps]);

  // Previne scroll do body com a roda dentro do menu
  const handleScrollCapture = (e) => {
    e.stopPropagation();
  };

  return (
    <components.MenuList
      {...props}
      innerRef={listRef}
      onWheel={handleWheel}
      onScrollCapture={handleScrollCapture}
    />
  );
};

// Wrapper que controla a abertura do menu para permitir fechamento programático
const AutoCloseSelect = ({ components: comp, styles, ...rest }) => {
  const [menuOpen, setMenuOpen] = useState(false);

  return (
    <ReactSelect
      {...rest}
      menuIsOpen={menuOpen}
      onMenuOpen={() => setMenuOpen(true)}
      onMenuClose={() => setMenuOpen(false)}
      // expõe o setter para os componentes filhos
      __setMenuOpen={setMenuOpen}
      components={{
        MenuList: AutoCloseMenuList,
        ...(comp || {})
      }}
      styles={{
        // mantém os estilos passados e garante que o menu tenha rolagem própria
        menuList: (base) => ({ ...base, maxHeight: 240, overflowY: 'auto' }),
        ...(styles || {})
      }}
      closeMenuOnScroll={false}
      // impede que a rolagem do body feche o menu acidentalmente
      blurInputOnSelect={false}
      backspaceRemovesValue={false}
    />
  );
};

export default AutoCloseSelect;
